import { IApiError } from '@frontend/request';

import {
  IBulkCloseMarketOrderParams,
  IBulkCloseMarketOrderResponse,
  IBulkClosePendingOrderParams,
  IBulkClosePendingOrderResponse,
  ICloseMarketOrderParams,
  IClosePendingOrderParams,
  ICreateMarketOrderParams,
  ICreatePendingOrderParams,
  IUpdateMarketOrderParams,
  IUpdatePendingOrderParams,
  tradeAPI
} from '@aqx-core/common/api/trade';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class TradeAPIController {
  public closeMarketOrder = async (params: ICloseMarketOrderParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await tradeAPI.closeMarketOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public closePendingOrder = async (params: IClosePendingOrderParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await tradeAPI.closePendingOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public bulkCloseMarketOrder = async (
    params: IBulkCloseMarketOrderParams,
    callbacks: IAPIControllerCallbacks<IBulkCloseMarketOrderResponse>
  ) => {
    try {
      const { result } = await tradeAPI.bulkCloseMarketOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public createPendingOrder = async (
    params: ICreatePendingOrderParams,
    callbacks: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await tradeAPI.createPendingOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public updatePendingOrder = async (
    params: IUpdatePendingOrderParams,
    callbacks: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await tradeAPI.updatePendingOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public bulkDeletePendingOrder = async (
    params: IBulkClosePendingOrderParams[],
    callbacks: IAPIControllerCallbacks<IBulkClosePendingOrderResponse>
  ) => {
    try {
      const { result } = await tradeAPI.bulkDeletePendingOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public createMarketOrder = async (params: ICreateMarketOrderParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await tradeAPI.createMarketOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public updateMarketOrder = async (params: IUpdateMarketOrderParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await tradeAPI.updateMarketOrder(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };
}

export const tradeAPIController = new TradeAPIController();
